import { __require as requireSemver } from "../classes/semver.js";
var major_1;
var hasRequiredMajor;
function requireMajor() {
  if (hasRequiredMajor) return major_1;
  hasRequiredMajor = 1;
  const SemVer = requireSemver();
  const major = (a, loose) => new SemVer(a, loose).major;
  major_1 = major;
  return major_1;
}
export {
  requireMajor as __require
};
//# sourceMappingURL=major.js.map
